import { createContext, useContext } from 'react';

interface FindingsContextProps {
  refresh: boolean;
  toggleRefresh: () => void;
}

export const FindingsContext = createContext<FindingsContextProps>({
  refresh: false,
  toggleRefresh: () => {},
});

export const FindingsContextProvider = FindingsContext.Provider;

export const useFindingsContext = () => useContext(FindingsContext);
